module.exports = __webpack_public_path__ + "img/personal-info.6674dfb7.png";